import { useState } from 'react';
import styles from 'widget/event_components/ticket-spot.scss';
import { Carousel } from 'react-bootstrap';
import Zoom from 'react-medium-image-zoom';

export const TicketImages = ({ ticket_images = [] }) => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  if (ticket_images.length === 0) return <span />;
  if (ticket_images && ticket_images.length > 1) {
    return (
      <div className={styles.ticketCarousel}>
        <Carousel activeIndex={index} onSelect={handleSelect}>
          {ticket_images.map((url) => (
            <Carousel.Item>
              <Zoom>
                <img className="d-block w-100" src={url} alt="Ticket" width={150} />
              </Zoom>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    );
  }
  return (
    <Zoom>
      <img src={ticket_images[0]} width={80} alt="Ticket" />
    </Zoom>
  );
};
